export const INSTALLATION_TYPES = {
  CLOUD: 'cloud',
  SELF_HOSTED_BILLING: 'self_hosted_billing',
  ENTERPRISE: 'enterprise',
  COMMUNITY: 'community',
};
